import { addDays, endOfDay } from 'date-fns';
export const generateEmptyBalances = (from, to) => {
    const balances = [];
    try {
        const dates = getDates(from, to);
        dates.reverse().forEach((date) => {
            balances.push({
                timestamp: String(date.toISOString()),
                balance: 0,
            });
        });
        return balances;
    }
    catch {
        return [];
    }
};
const getDates = (from, to) => {
    const adjustedFrom = endOfDay(new Date(from));
    const now = endOfDay(new Date(to));
    const dates = [];
    for (let stepFloor = adjustedFrom; stepFloor <= now; stepFloor = addDays(stepFloor, 1)) {
        dates.push(stepFloor);
    }
    return dates;
};
